module.exports = __webpack_public_path__ + "img/midia-festival-logo-2025.f1184193.png";